module.exports = __webpack_public_path__ + "static/media/Inter-Italic.7092ad88.ttf";